/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateContractorPenaltyCommandResult } from '../../models/create-contractor-penalty-command-result';

export interface ApiContractorPenaltiesCreateContractorPenaltyPost$Params {
      body?: {
'ProjectDailyTaskReportId'?: string;
'ProjectPenaltyDetailsTemplateId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiContractorPenaltiesCreateContractorPenaltyPost(http: HttpClient, rootUrl: string, params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContractorPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContractorPenaltiesCreateContractorPenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateContractorPenaltyCommandResult>;
    })
  );
}

apiContractorPenaltiesCreateContractorPenaltyPost.PATH = '/api/ContractorPenalties/CreateContractorPenalty';
